import { useEffect } from "react";
import { Outlet } from "react-router";
import GlobalNotificationErrorSnackbar from "../../../../shared/components/GlobalNotificationErrorSnackbar";
import GlobalNotificationSnackbar from "../../../../shared/components/GlobalNotificationSnackbar";
import { NotificationContextProvider } from "../../../../shared/contexts/NotificationContextProvider";
import sharedBiClient from "../../../../shared/reporting/api/biClient";
import { GroupsContextProvider } from "../../../../shared/reporting/components/groups/contexts/GroupsContextProvider";
import { BiApiClientProvider } from "../../../../shared/reporting/contexts/BiApiClientProvider";
import biClient from "../../../api/biApi";
import { BiApiClient } from "../../../contexts/ApiClientProviderContext";
import { useClientContext } from "../../../contexts/ClientContext";
import useReportMode from "../../../hooks/useReportMode";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch";
import { fieldsStateActions } from "../../../store/thunks/fieldStatesThunks";
import useReportGroups from "../common/hooks/useReportGroups";
import { getApiReportsUrl, getEditApiReportUrl, getViewApiReportUrl } from "../common/utilities/editReportUrl";

const ReportsContainer = () => {
  const { mode } = useReportMode();
  const dispatch = useAppDispatch();
  const { clientCode } = useClientContext();
  const { reportGroups, actions, ui } = useReportGroups({ reportUsage: "Api" });

  useEffect(() => {
    if (mode === "run") {
      //The mode can be changed from edit to run, so we need to reset the fields state
      dispatch(fieldsStateActions.resetFieldsState());
    }
  }, [mode, dispatch]);

  return (
    <BiApiClientProvider<BiApiClient>
      api={{
        ...biClient.apiReports,
        ...sharedBiClient.apiReports,
        getEditReportUrl: getEditApiReportUrl,
        getViewReportUrl: getViewApiReportUrl,
        getReportsUrl: getApiReportsUrl,
      }}
    >
      <GroupsContextProvider groups={{ [clientCode]: reportGroups }} ui={ui} actions={actions}>
        <NotificationContextProvider>
          <Outlet />
          <GlobalNotificationSnackbar />
          <GlobalNotificationErrorSnackbar />
        </NotificationContextProvider>
      </GroupsContextProvider>
    </BiApiClientProvider>
  );
};

export default ReportsContainer;
